"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const core_1 = require("@material-ui/core");
const withStyles_1 = require("@material-ui/core/styles/withStyles");
const classnames_1 = require("classnames");
const color = require("color");
const react_i18next_1 = require("react-i18next");
const EntriesBoxDark = ({ entries, loading = false, classes }) => {
    const numOfEntries = entries ? entries : 0;
    const { t } = (0, react_i18next_1.useTranslation)();
    return ((0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: (0, jsx_runtime_1.jsx)("div", Object.assign({ className: (0, classnames_1.default)(classes.entriesBox, classes.entriesBoxDark) }, { children: (0, jsx_runtime_1.jsx)(core_1.Grid, Object.assign({ container: true, direction: "column" }, { children: (0, jsx_runtime_1.jsx)(core_1.Grid, Object.assign({ item: true }, { children: (0, jsx_runtime_1.jsxs)(core_1.Grid, Object.assign({ container: true, direction: "row" }, { children: [(0, jsx_runtime_1.jsx)(core_1.Grid, Object.assign({ item: true, className: (0, classnames_1.default)(classes.entriesGrid, classes.entriesGridDark) }, { children: (0, jsx_runtime_1.jsx)("div", Object.assign({ className: classes.entriesButton }, { children: loading ? ((0, jsx_runtime_1.jsx)(core_1.CircularProgress, { color: 'secondary', size: 25 })) : ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(core_1.Typography, Object.assign({ className: classes.text, color: 'secondary' }, { children: numOfEntries === 1 ? numOfEntries + ' Entry' : numOfEntries.toPointsFormat() + ' Entries' })), (0, jsx_runtime_1.jsx)(core_1.Typography, Object.assign({ className: classes.textSmall, color: 'secondary' }, { children: numOfEntries }))] })) })) })), (0, jsx_runtime_1.jsx)(core_1.Grid, Object.assign({ item: true, className: classes.spacing }, { children: (0, jsx_runtime_1.jsx)(core_1.Typography, Object.assign({ color: 'primary', className: classes.description }, { children: t('drawDetails.yourEntriesThisDraw') })) }))] })) })) })) })) }));
};
const styles = (theme) => (0, core_1.createStyles)({
    spacing: {
        padding: theme.spacing(2),
        [theme.breakpoints.down('md')]: {
            paddingLeft: theme.spacing(),
            paddingRight: theme.spacing()
        }
    },
    entriesBox: {
        marginTop: theme.spacing(2),
        marginBottom: theme.spacing(2),
        borderRadius: theme.spacing()
    },
    entriesBoxDark: {
        border: `1px solid ${color(theme.palette.primary.main).alpha(0.3).rgb().string()}`
    },
    entriesButton: {
        borderRadius: 5,
        marginRight: theme.spacing(2),
        padding: theme.spacing(2),
        [theme.breakpoints.down('md')]: {
            marginRight: theme.spacing(),
            paddingLeft: theme.spacing(),
            paddingRight: theme.spacing()
        },
        [theme.breakpoints.down('sm')]: {
            marginRight: 0
        }
    },
    entriesGrid: {
        borderRadius: '8px 0 0 8px'
    },
    entriesGridDark: {
        backgroundColor: color(theme.palette.primary.main).alpha(0.2).rgb().string()
    },
    description: Object.assign(Object.assign({}, theme.typography.body1), { [theme.breakpoints.down('md')]: Object.assign({}, theme.typography.body2) }),
    text: Object.assign(Object.assign({}, theme.typography.body1), { [theme.breakpoints.down('md')]: Object.assign({}, theme.typography.body2), ['@media (max-width:364px)']: {
            display: 'none'
        } }),
    textSmall: {
        ['@media (min-width:365px)']: Object.assign({ display: 'none' }, theme.typography.body2)
    }
});
exports.default = (0, withStyles_1.default)(styles)(EntriesBoxDark);
//# sourceMappingURL=EntriesBoxDark.js.map